import { render, staticRenderFns } from "./CustomerModified.vue?vue&type=template&id=6791c43c&scoped=true&"
import script from "./CustomerModified.vue?vue&type=script&lang=js&"
export * from "./CustomerModified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791c43c",
  null
  
)

export default component.exports